// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import style from "./OutputForm.module.scss";
import { getImageUrl } from "../../../../commons/assets_path";
import { OutputValue } from "./types/types";
import { useDebounce } from "../../../../hooks/useDebounce";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import { useTranslation } from "react-i18next";

type Props = {
  outputLabel: OutputValue;
  setOutputLabels: (outputLabels: OutputValue[]) => void;
  i: number;
  iconPath: string;
  isDisplayNameEditable: boolean;
  isTestValueEditable: boolean;
  template_class_name: string;
  length: number;
  client_id: number;
  workflow_template_id: number;
  selectable_data_type: string;
  outputLabels: OutputValue[];
  addFlg: boolean;
};

export const AppOutputLabel = ({
  outputLabel,
  setOutputLabels,
  i,
  iconPath,
  isDisplayNameEditable,
  isTestValueEditable,
  template_class_name,
  length,
  client_id,
  workflow_template_id,
  selectable_data_type,
  outputLabels,
  addFlg,
}: Props) => {
  const { t } = useTranslation();
  const [labelValue, setLabelValue] = useState<OutputValue>(outputLabel);
  const [editValue, setEditValue] = useState<OutputValue | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showEdit, setShowEdit] = useState<boolean>(false);
  const [destroy, setDestroy] = useState<boolean>(false);
  const [display, setDisplay] = useState<string>("flex");
  const [jsonPath, setJsonPath] = useState<string>(outputLabel?.name || "");
  const debouncedJsonPath = useDebounce(jsonPath, 200);
  const titleRef = useRef<HTMLDivElement>(null);
  const valueRef = useRef<HTMLDivElement>(null);
  const isSubmitDisabled =
    editValue?.display_name === "" || (editValue?.data_type !== "file" && editValue?.name === "");

  const outputDuplicationCheck = async (name) => {
    const additionalOutputDisplayNames = outputLabels
      .filter((outputLabel, index) => index !== i && !outputLabel.target_id && !outputLabel?._destroy)
      .map((outputLabel) => outputLabel.display_name);
    await axios
      .post(
        location.href.replace(
          /workflow_templates.*/,
          `workflow_templates/${window.location.pathname.split("/")[3]}/ajax_output_duplication`,
        ),
        {
          target_display_name: name,
          target_id: labelValue?.target_id,
          additional_output_display_names: additionalOutputDisplayNames,
        },
      )
      .then((res) => {
        setEditValue((prevLabelValue) => ({ ...prevLabelValue, is_duplicated: res.data.is_duplicated }));
        setLabelValue((prevLabelValue) => ({ ...prevLabelValue, is_duplicated: res.data.is_duplicated }));
      });
  };

  const editLabel = () => {
    setEditValue(labelValue);
    setShowModal(true);
    addOutputAreaClose();
  };

  const addOutputAreaClose = () => {
    const addOutputArea = document.querySelector(".js-add_output_area");
    if (addOutputArea) {
      addOutputArea.style.display = "none";
    }
  };

  const submit = () => {
    if (editValue) {
      setLabelValue(editValue);
      setShowModal(false);
    }
  };

  const changeModalHeight = (showModal) => {
    if (document.getElementById("outputLabels")) {
      const outputLabels = document.getElementById("outputLabels");
      if (showModal) {
        outputLabels.style.minHeight = "355px";
        if (!editValue?.is_default_output) {
          outputLabels.scrollTo({
            top: outputLabels.scrollTop + 250,
            behavior: "smooth",
          });
        }
      } else {
        outputLabels.style.minHeight = "auto";
      }
    }
  };

  const close = () => {
    setDisplay("none");
    setDestroy(1);
    const updatedLabels = outputLabels.map((currentLabel, index) => {
      if (index === i) {
        // iは現在のラベルのインデックス
        return { ...currentLabel, _destroy: true };
      }
      return currentLabel;
    });

    // 更新されたラベルの配列でsetOutputLabelsを呼び出す
    setOutputLabels(updatedLabels);
  };

  const changeName = (name) => {
    const _copy = JSON.parse(JSON.stringify(editValue));
    _copy.display_name = name;
    setEditValue(_copy);

    const updatedLabels = outputLabels.map((outputLabel, index) => {
      if (index === i) {
        return { ...outputLabel, display_name: name };
      }
      return outputLabel;
    });
    // 更新されたラベルの配列でsetOutputLabelsを呼び出す
    setOutputLabels(updatedLabels);

    outputDuplicationCheck(name);
  };

  const transformResultData = (data: any) => {
    return data.result.map((element: any) => {
      if (element === null) {
        return "";
      } else if (typeof element === "object") {
        return JSON.stringify(element);
      } else {
        return element;
      }
    });
  };

  const getJsonPathValue = async (jsonPathInputValue: string) => {
    const apiRequestTestResult = $(".js-api_request_test_result").val();
    if (!jsonPathInputValue || !editValue) return;
    const res = await axios.post("ajax_json_path_test", {
      api_request_test_result: apiRequestTestResult,
      json_path: jsonPathInputValue,
    });

    if (res?.data?.result) {
      const resultData = transformResultData(res.data);
      const _copy = JSON.parse(JSON.stringify(editValue));
      _copy.name = jsonPathInputValue;
      _copy.test_value = resultData.join("[,]");
      _copy.readonly_test_value = resultData.join(",");
      setEditValue(_copy);
    } else {
      const _copy = JSON.parse(JSON.stringify(editValue));
      _copy.name = jsonPathInputValue;
      _copy.test_value = "";
      _copy.readonly_test_value = "";
      setEditValue(_copy);
    }
  };

  useEffect(() => {
    if (editValue?.test_value) {
      const _copy = editValue.test_value.replace(/\n/g, " ");
      setEditValue((prevState) => ({ ...prevState, test_value: _copy }));
    }
    if (showModal) {
      document.getElementsByName("set_trigger")[0].disabled = true;
    } else {
      document.getElementsByName("set_trigger")[0].disabled = false;
    }
    changeModalHeight(showModal);
  }, [showModal]);

  useEffect(() => {
    if (debouncedJsonPath) {
      getJsonPathValue(debouncedJsonPath);
    } else if (editValue) {
      const _copy = JSON.parse(JSON.stringify(editValue));
      _copy.name = debouncedJsonPath;
      _copy.test_value = "";
      _copy.readonly_test_value = "";
      setEditValue(_copy);
    }
  }, [debouncedJsonPath]);

  return (
    <div id={`outputLabel${outputLabel.target_id}`} style={{ position: "relative", display: display, width: "100%" }}>
      {template_class_name === "api_operation_template" ? (
        <input
          type="hidden"
          name="api_operation_template[workflow_template_action_attributes][id]"
          id="api_operation_template_workflow_template_action_attributes_id"
          value={workflow_template_id}
        />
      ) : (
        <input
          type="hidden"
          name={
            template_class_name === "browser_extension_trigger"
              ? `${template_class_name}[workflow_template_attributes][id]`
              : `${template_class_name}[app_trigger_attributes][workflow_template_attributes][id]`
          }
          id={`${template_class_name}_app_trigger_attributes_workflow_template_attributes_id`}
          value={workflow_template_id}
        />
      )}
      <div
        className={`${style.outputLabelWrap} js-trigger-output- js-workflow_template_action_output_text_field`}
        style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", position: "relative" }}
        onMouseOver={() => setShowEdit(true)}
        onMouseLeave={() => setShowEdit(false)}
      >
        {labelValue.is_duplicated && (
          <img className={style.outputLabelIcon} src={getImageUrl("images/icons/informationRed.svg")}></img>
        )}
        <img className={style.outputLabelIcon} src={iconPath}></img>
        <div className={`${style.outputLabelTitle}`} ref={titleRef}>
          {labelValue.display_name}
        </div>
        <div
          className={`${style.outputLabelValue}`}
          ref={valueRef}
          dangerouslySetInnerHTML={{
            __html: labelValue?.readonly_test_value ? labelValue?.readonly_test_value?.replace(/\\n/g, " ") : "",
          }}
        />

        {template_class_name === "api_operation_template" ? (
          <>
            <input
              disabled={true}
              className="form-control js-api_operation_template_test_value_readonly"
              data-target-id={outputLabel.target_id}
              value={labelValue?.readonly_test_value}
              type="hidden"
              name={`api_operation_template[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][test_value_readonly]`}
              id={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_test_value_readonly`}
            />
            <input
              className="form-control js-workflow_template_action_output_display_name_field"
              data-target-id={outputLabel.target_id}
              value={labelValue?.display_name}
              type="hidden"
              name={`api_operation_template[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][display_name]`}
              id={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_display_name`}
            />
            <input
              className="form-control"
              data-target-id={outputLabel.target_id}
              value={outputLabel.target_id}
              type="hidden"
              name={`api_operation_template[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][id]`}
              id={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_id`}
            />
            <input
              className="form-control js-workflow_template_action_output_name_form"
              type="hidden"
              name={`api_operation_template[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][name]`}
              id={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_name`}
              value={labelValue?.name}
            />
            <input
              className="js-workflow_template_action_output_data_type_form"
              type="hidden"
              name={`api_operation_template[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][data_type]`}
              id={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_data_type`}
              value={labelValue?.data_type}
            />
            <div className="js-workflow_template_action_output_test_value_field">
              <input
                className="js-api_operation_template_test_value"
                type="hidden"
                name={`api_operation_template[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][test_value]`}
                id={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_test_value`}
                value={labelValue.test_value.replace(/\\n/g, "\n")}
              />
            </div>
            {editValue?.data_type === "file" && (
              <input
                style={{ display: "none" }}
                className="custom-file-input js-file_test_value test-workflow_template_action_output_file_form"
                type="file"
                name={`api_operation_template[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][output_test_attachment_file]`}
                id={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_output_test_attachment_file`}
                onChange={(e) => {
                  setEditValue({
                    ...editValue,
                    readonly_test_value: e.target.files[0].name,
                    test_value: e.target.files[0].name,
                  });
                }}
              />
            )}
            <input
              type="hidden"
              value={client_id}
              name={`api_operation_template[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][client_id]`}
              id={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_client_id`}
            />
            <input
              type="hidden"
              value={workflow_template_id}
              name={`api_operation_template[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][workflow_template_id]`}
              id={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_workflow_template_id`}
            />
            <input
              type="hidden"
              value={destroy}
              name={`api_operation_template[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][_destroy]`}
              id={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_workflow__destroy`}
            />
          </>
        ) : (
          <>
            <input
              disabled={true}
              className="form-control js-api_operation_template_test_value_readonly"
              data-target-id={outputLabel.target_id}
              value={labelValue?.readonly_test_value}
              type="hidden"
              name={
                template_class_name === "browser_extension_trigger"
                  ? `${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][test_value_readonly]`
                  : `${template_class_name}[app_trigger_attributes][workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][test_value_readonly]`
              }
              id={`${template_class_name}_app_trigger_attributes_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_test_value_readonly`}
            />
            <input
              className="form-control js-workflow_template_action_output_display_name_field"
              data-target-id={outputLabel.target_id}
              value={labelValue?.display_name}
              type="hidden"
              name={
                template_class_name === "browser_extension_trigger"
                  ? `${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][display_name]`
                  : `${template_class_name}[app_trigger_attributes][workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][display_name]`
              }
              id={`${template_class_name}_app_trigger_attributes_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_display_name`}
            />
            <input
              className="form-control js-workflow_template_action_output_display_name_field"
              data-target-id={outputLabel.target_id}
              value={outputLabel.target_id}
              type="hidden"
              name={
                template_class_name === "browser_extension_trigger"
                  ? `${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][id]`
                  : `${template_class_name}[app_trigger_attributes][workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][id]`
              }
              id={`${template_class_name}_app_trigger_attributes_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_id`}
            />
            <input
              className="js-workflow_template_action_output_name_form"
              type="hidden"
              name={
                template_class_name === "browser_extension_trigger"
                  ? `${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][name]`
                  : `${template_class_name}[app_trigger_attributes][workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][name]`
              }
              id={`${template_class_name}_app_trigger_attributes_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_name`}
              value={labelValue?.name}
            />
            <input
              className="js-workflow_template_action_output_data_type_form"
              type="hidden"
              name={
                template_class_name === "browser_extension_trigger"
                  ? `${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][data_type]`
                  : `${template_class_name}[app_trigger_attributes][workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][data_type]`
              }
              id={`${template_class_name}_app_trigger_attributes_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_data_type`}
              value={labelValue?.data_type}
            />
            <div className="js-workflow_template_action_output_test_value_field">
              <input
                className="js-api_operation_template_test_value"
                type="hidden"
                name={
                  template_class_name === "browser_extension_trigger"
                    ? `${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][test_value]`
                    : `${template_class_name}[app_trigger_attributes][workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][test_value]`
                }
                id={`${template_class_name}_app_trigger_attributes_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_test_value`}
                value={labelValue.test_value.replace(/\\n/g, "\n")}
              />
            </div>
            {(template_class_name === "app_trigger_api_webhook" ||
              template_class_name === "app_trigger_webhook" ||
              template_class_name === "app_trigger_polling") && (
              <input
                type="hidden"
                name={`${template_class_name}[app_trigger_attributes][workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][boot_bind]`}
                id={`${template_class_name}_app_trigger_attributes_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_boot_bind`}
                value={labelValue.boot_bind}
              />
            )}
            <input
              type="hidden"
              value={client_id}
              name={
                template_class_name === "browser_extension_trigger"
                  ? `${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][client_id]`
                  : `${template_class_name}[app_trigger_attributes][workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][client_id]`
              }
              id={`${template_class_name}_app_trigger_attributes_workflow_template_attributes_${i}_client_id`}
            />
            <input
              type="hidden"
              value={workflow_template_id}
              name={
                template_class_name === "browser_extension_trigger"
                  ? `${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][workflow_template_id]`
                  : `${template_class_name}[app_trigger_attributes][workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][workflow_template_id]`
              }
              id={`${template_class_name}_app_trigger_attributes_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_workflow_template_id`}
            />
            <input
              type="hidden"
              value={destroy}
              name={
                template_class_name === "browser_extension_trigger"
                  ? `${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][_destroy]`
                  : `${template_class_name}[app_trigger_attributes][workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][_destroy]`
              }
              id={`${template_class_name}_app_trigger_attributes_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_workflow__destroy`}
            />
          </>
        )}

        {(isDisplayNameEditable || isTestValueEditable) &&
          showEdit &&
          document.getElementsByClassName("output-edit-modal").length === 0 && (
            <>
              <img
                className="test-edit_output_btn"
                src={getImageUrl("images/icons/editGray.svg")}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  editLabel();
                }}
              />
              {!outputLabel.is_default_output && (
                <img
                  src={getImageUrl("images/icons/close.svg")}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    close();
                  }}
                />
              )}
            </>
          )}
      </div>
      {showModal && (
        <div className={`${style.outputEditModal} output-edit-modal`}>
          <div className={style.outputEditContent}>
            {outputLabel.is_default_output ? (
              <div className={style.outputEditRow}>
                <div className={style.outputEditElement}>
                  <div className={style.outputEditTitle}>{t("AppOutputLabel.項目名")}</div>
                  <input
                    className={`${style.outputEditInput} ${
                      editValue?.is_duplicated && "output-duplication-warning"
                    } app_output_display_name-test`}
                    value={editValue?.display_name}
                    readOnly={!isDisplayNameEditable}
                    style={{
                      color: !isDisplayNameEditable && "#777777",
                      backgroundColor: !isDisplayNameEditable && "#F3F3F3",
                    }}
                    onChange={(e) => {
                      changeName(e.target.value);
                    }}
                  />
                  {editValue?.is_duplicated && (
                    <div className="output-duplication-warning-feedback">
                      {t(
                        "AppOutputLabel.項目名が重複しています。項目名が重複している場合、値が上書きされますのでご注意ください。",
                      )}
                    </div>
                  )}
                </div>
                <div className={style.outputEditElement}>
                  <div className={style.outputEditTitle}>{t("AppOutputLabel.テストで取得した値")}</div>
                  <input
                    className={`${style.outputEditInput} app_output_readonly_test_value-test`}
                    readOnly={!isTestValueEditable}
                    style={{
                      color: !isTestValueEditable && "#777777",
                      backgroundColor: !isTestValueEditable && "#F3F3F3",
                    }}
                    value={editValue?.test_value.replace(/\\n/g, " ")}
                  ></input>
                </div>
              </div>
            ) : (
              <>
                <div className={style.outputEditRow}>
                  <div className={style.outputEditElement}>
                    <div className={style.outputEditTitle}>{t("AppOutputLabel.項目名")}</div>
                    <input
                      className={`${style.outputEditInput} ${
                        editValue?.is_duplicated && "output-duplication-warning"
                      } app_output_display_name-test`}
                      value={editValue?.display_name}
                      readOnly={!isDisplayNameEditable}
                      style={{
                        color: !isDisplayNameEditable && "#777777",
                        backgroundColor: !isDisplayNameEditable && "#F3F3F3",
                      }}
                      onChange={(e) => {
                        changeName(e.target.value);
                      }}
                    />
                    {editValue?.is_duplicated && (
                      <div className="output-duplication-warning-feedback">
                        {t(
                          "AppOutputLabel.項目名が重複しています。項目名が重複している場合、値が上書きされますのでご注意ください。",
                        )}
                      </div>
                    )}
                  </div>
                  <div className={style.outputEditElement}>
                    <div className={style.outputEditTitle}>{t("AppOutputLabel.入力形式")}</div>
                    <select
                      className="form-control app_output_data_type-test"
                      onChange={(e) => {
                        const _copy = JSON.parse(JSON.stringify(editValue));
                        if (_copy.data_type === "file") {
                          _copy.readonly_test_value = labelValue.readonly_test_value;
                          _copy.test_value = labelValue.test_value;
                        }
                        _copy.data_type = e.target.value;
                        if (e.target.value === "file") {
                          _copy.readonly_test_value = "";
                          _copy.test_value = "";
                        }
                        setEditValue(_copy);
                      }}
                      value={editValue?.data_type}
                    >
                      {JSON.parse(selectable_data_type).map((selection, i) => (
                        <option key={i} value={selection[Object.keys(selection)[0]]}>
                          {Object.keys(selection)[0]}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className={style.outputEditRow}>
                  {template_class_name === "api_operation_template" && editValue?.data_type === "file" ? (
                    <>
                      <div className={style.outputEditElement}>
                        <div
                          className="field js-workflow_template_action_output_file_field js-api_operation_attachment_template_attachment_field"
                          style={{ width: "100%" }}
                        >
                          <div className="form-group">
                            <label
                              htmlFor={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_output_test_attachment_file`}
                            >
                              {t("AppOutputLabel.添付ファイル")}
                            </label>
                            <div className="custom-file">
                              <label
                                className="custom-file-label"
                                htmlFor={`api_operation_template_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_output_test_attachment_file`}
                                style={{ cursor: "pointer" }}
                              >
                                {editValue.readonly_test_value
                                  ? editValue.readonly_test_value
                                  : t("AppOutputLabel.ファイルを選択してください")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={style.outputEditElement}>
                        <div className={style.outputEditTitle}>JSONPath</div>
                        <input
                          className={`${style.outputEditInput}`}
                          value={jsonPath}
                          onChange={(e) => setJsonPath(e.target.value)}
                        />
                      </div>
                      <div className={style.outputEditElement}>
                        <div className={style.outputEditTitle}>{t("AppOutputLabel.テストで取得した値")}</div>
                        <input
                          className={`${style.outputEditInput} app_output_readonly_test_value-test`}
                          style={{
                            color: !isTestValueEditable && "#777777",
                            backgroundColor: !isTestValueEditable && "#F3F3F3",
                          }}
                          value={
                            editValue?.readonly_test_value ? editValue.readonly_test_value.replace(/\\n/g, " ") : ""
                          }
                        ></input>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
          <div className={style.outputEditButtonRow}>
            <div
              className="btn btn-secondary test-cancel_output_btn"
              style={{ fontSize: "16px", padding: "6px", height: "44px" }}
              onClick={() => {
                setShowModal(false);
                changeModalHeight(false);
              }}
            >
              {t("AppOutputLabel.キャンセル")}
            </div>
            <button
              className="btn btn-info test_save_output_btn"
              style={{
                fontSize: "16px",
                padding: "6px",
                height: "44px",
              }}
              disabled={isSubmitDisabled}
              onClick={() => {
                submit();
              }}
            >
              {t("AppOutputLabel.保存")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
